import { tagsById as exif } from './tags/exif';
import { tagsById as gps } from './tags/gps';
import { tagsById as standard } from './tags/standard';
import TIFFDecoder from './tiffDecoder';
import TiffIfd from './tiffIfd';
function decodeTIFF(data, options) {
    const decoder = new TIFFDecoder(data);
    return decoder.decode(options);
}
function isMultiPage(data) {
    const decoder = new TIFFDecoder(data);
    return decoder.isMultiPage;
}
function pageCount(data) {
    const decoder = new TIFFDecoder(data);
    return decoder.pageCount;
}
const tagNames = {
    exif,
    gps,
    standard,
};
export { decodeTIFF as decode, isMultiPage, pageCount, TiffIfd, tagNames, };
//# sourceMappingURL=index.js.map